export default {
    layout : {
        carregando: 'Loading...'
    }
}